import { isChain, type Chain } from '@incpt/shared';

/** `startapp` prefix for a direct link to a coin / INCPT screen. */
export const TOKEN_PREFIX = 'token_';

export type TokenDeepLinkTarget = { kind: 'coin'; symbol: string; chain: Chain } | { kind: 'incpt' };

/**
 * Parse Mini App `start_param` into a token deep link.
 * Formats: `token_USDT_trx`, `token_ETH_eth`, `token_INCPT`.
 * Must stay within Telegram's startapp charset (A–Z a–z 0–9 _ -) and ≤64 chars.
 */
export function parseTokenStartParam(
  startParam: string | null | undefined,
): TokenDeepLinkTarget | null {
  if (!startParam || !startParam.startsWith(TOKEN_PREFIX)) return null;
  const rest = startParam.slice(TOKEN_PREFIX.length);
  if (!rest) return null;

  if (/^INCPT$/i.test(rest)) return { kind: 'incpt' };

  const m = /^([A-Za-z0-9]+)_([A-Za-z0-9]+)$/.exec(rest);
  if (!m) return null;
  const symbol = m[1]!.toUpperCase();
  const chain = m[2]!.toLowerCase();
  if (!isChain(chain)) return null;
  return { kind: 'coin', symbol, chain };
}

/** Read `start_param` from Telegram WebApp (unsafe object or signed initData). */
export function readTelegramStartParam(): string | null {
  const wa = window.Telegram?.WebApp;
  const unsafe = wa?.initDataUnsafe?.start_param;
  if (typeof unsafe === 'string' && unsafe.length > 0) return unsafe;
  const initData = wa?.initData;
  if (!initData) return null;
  try {
    return new URLSearchParams(initData).get('start_param');
  } catch {
    return null;
  }
}
